<div class="custom-component-wrapper" [style]="wrapperStyle()">
  <div class="custom-component-inner" [class.has-border]="block().show_border === true" [style]="containerStyle()">
    @if (!registryEntry()) {
      <div class="custom-component-error">Component not found: {{ block().component_id }}</div>
    }
    <ng-container #componentHost></ng-container>
  </div>
</div>
